import { message, notification } from 'antd'

/** Seconds a toast message (success / error after a mutation) stays on screen. Antd default is 3. */
export const MESSAGE_DURATION_SECONDS = 15

/** Seconds an error notification stays on screen. Antd default is 4.5. */
export const NOTIFICATION_DURATION_SECONDS = 15

/**
 * Global defaults for antd's static `message` / `notification` APIs.
 * Both are configured here so feedback (including `showApiErrorNotification`)
 * stays visible long enough to read. Individual calls can still pass their own
 * `duration` to override these.
 */
export const antdInit = () => {
  message.config({ duration: MESSAGE_DURATION_SECONDS })
  notification.config({ duration: NOTIFICATION_DURATION_SECONDS })
}
